import MIKE_COLORS from '../../styles/mike-colors';

export const bgLightGreyStyle = {
  backgroundColor: MIKE_COLORS.XLIGHTGREY
}

export const tableHeadStyle = {
  borderBottom: '1px solid ' + MIKE_COLORS.DARKGREY_DEFAULT,
  color: MIKE_COLORS.BRANDBLUE_DEFAULT
}

export const tableRowBorderStyle = {
  borderBottom: '1px solid ' + MIKE_COLORS.MEDIUMGREY_DEFAULT,
}

export const contentScrollbarStyle = {
  overflowY: 'auto',
  marginRight: '0px !important',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    background: MIKE_COLORS.MEDIUMGREY_DEFAULT,
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: MIKE_COLORS.DARKGREY_DEFAULT,
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: MIKE_COLORS.BRANDBLUE_DEFAULT,
  },
}

export const meshDialogContentWrapperStyle = {
  padding: '0 !important',
  backgroundColor: MIKE_COLORS.XLIGHTGREY,
}

